import { useEffect, useState } from "react";
import Subheader from "../todoList/subheader";
import { resources_EN } from "../componentUtils";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Path } from "../../RoutesUtils";
import { PostService } from "../../services/genericPostService";
import Header from "../header/header";

export default function Addtask() {
  const [formData, setFormData] = useState({
    medTitle: "",
    medQuantity: "",
    medDate: "",
    medComments: "",
  });
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      navigate(Path.login);
    }
  }, []);

  const onChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  /* Submit */
  const submitData = () => {
    const validate = validation();
    if (validate) {
      const data = {
        user_id: userId,
        medicine_title: formData.medTitle,
        medicine_quantity: formData.medQuantity,
        reminder_date: formData.medDate,
        comments: formData.medComments,
      };
      const url = "/fmeApi/add_medicine_prescription.php";
      PostService(url, data, modal);
    }
  };

  const modal = (icon, title, message) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: message,
    }).then((resp) => {
      if (resp.isConfirmed && icon === resources_EN.success) {
        navigate(Path.prescription);
      }
    });
  };

  const validation = () => {
    if (formData.medTitle.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyMedTitle
      );
      return false;
    }
    if (formData.medDate.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyMedDate
      );
      return false;
    }
    if (formData.medQuantity.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyMedQuantity
      );
      return false;
    }
    if (formData.medComments.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyMedComments
      );
      return false;
    }
    return true;
  };

  return (
    <>
      <Header />
      <Subheader title="Tilføj opgave" />
      <div className="max-w-xl mx-auto lg:px-8 px-4 mt-12 lg:space-y-8 space-y-5 mb-8">
        <div className="space-y-2">
          <label htmlFor="title" className="block text-sm font-medium">
            Medicine Title *
          </label>
          <input
            type="text"
            id="title"
            className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
            placeholder="Enter Medicine Title"
            onChange={onChange}
            name="medTitle"
            value={formData.medTitle}
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="title" className="block text-sm font-medium">
            Medicine Quantity *
          </label>
          <input
            type="text"
            id="title"
            className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
            placeholder="Enter Medicine Quantity"
            value={formData.medQuantity}
            onChange={onChange}
            name="medQuantity"
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="title" className="block text-sm font-medium">
            Out of stock reminder date *
          </label>
          <input
            type="date"
            id="title"
            className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
            placeholder="Enter Medicine Stock"
            name="medDate"
            value={formData.medDate}
            onChange={onChange}
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="description" className="block text-sm font-medium">
            Comments
          </label>
          <textarea
            type="text"
            id="description"
            className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
            placeholder="Enter Medicine Comments"
            value={formData.medComments}
            onChange={onChange}
            name="medComments"
          />
        </div>

        <div className="flex justify-center pt-5">
          <button
            type="button"
            className="py-1.5 px-16 border border-transparent rounded-full text-sm font-normal text-white bg-theme focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme cursor-pointer"
            onClick={submitData}
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
}
